<!-- 검교정 이력 상세 -->
<template>
    <vvo v-slot="v">
        <div class="detail-container">
            <!-- 1. 데이터 없음 표시 영역 -->
            <div class="detail-placeholder" v-if="!detailInfo && !isNewMode">
                <span class="detail-notification-icon">
                    <i class="fas fa-external-link-alt"></i>
                </span>
                <span class="detail-notification-text">유지보수 이력을 선택하세요.</span>
            </div>
            <!-- 2.상세 정보 영역 -->
            <div v-if="detailInfo || isNewMode" class="detail-content-container">
                <!-- 2.1 상세 정보 헤더 영역 -->
                <div class="detail-header" v-if="detailInfo || isNewMode">
                    <div class="detail-title">
                        <span class="title">{{ viewTitle }}</span>
                        <span class="badge title1" v-b-tooltip.hover title="계측기 식별번호">
                            {{ selectedRow?.facilityIdx || "신규" }}
                        </span>
                        <span class="badge title2"> {{ selectedRow?.facilityName || "신규" }} </span>
                        <span class="badge others">
                            {{ transMeterTypeCode(selectedRow?.meterTypeCode) || "신규" }}
                        </span>
                        <span class="badge title3 " v-b-tooltip.hover title="유지보수 식별번호">
                            {{ selectedRow?.clbrtnIdx || "신규" }}
                        </span>
                    </div>
                    <div class="detail-control" v-if="!isNewMode">
                        <b-form-checkbox switch v-model="isEditMode" size="lg" />
                    </div>
                </div>

                <!-- 2.2 상세 정보 컨텐츠 표시 영역 -->
                <div class="detail-content" v-if="detailInfo || isNewMode">
                    <BaseInfoPanel
                        ref="basePanel"
                        :mode="mode"
                        :clbrnTypeCodeList="clbrnTypeCodeList"
                        :selectedRow="selectedRow"
                        :facilityList="facilityList"
                        :model="selectedDetail"
                    />
                </div>
            </div>

            <!-- 3.하단 영역 -->
            <div class="detail-bottom">
                <!-- 3.2 하단 제어 버튼 -->
                <div class="detail-bottom-buttons">
                    <button
                        type="button"
                        class="btn btn-primary detail-btn"
                        v-if="isEditMode"
                        @click="onValidate(v, saveData)"
                    >
                        저장
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary detail-btn"
                        v-if="detailInfo || isNewMode"
                        @click="handleClose($event)"
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    </vvo>
</template>

<script>
import BaseInfoPanel from "./panels/BaseInfoPanel.vue";
import backEndApi from "@src/api/backEndApi";
// import moment from "moment";
import * as popupMessages from "@src/consts/popupMessageConsts";
import { mapState } from "vuex";

export default {
    components: {
        BaseInfoPanel,
    },
    props: ["title", "clbrnTypeCodeList", "selectedRow", "allDetails", "facilityList"],
    async created() {},
    mounted() {},
    data() {
        return {
            detailInfo: null,
            detailList: [],
            selectedDetail: null,
            // facilityList: [],
            mode: "view", // 편집모드 : edit/view
            popupMessages,
        };
    },
    computed: {
        ...mapState({
            meterTypeCodeList: (state) => state.commonCodes.meterTypeCode,
        }),
        isEditMode: {
            get() {
                return this.mode == "edit" || this.mode == "new";
            },
            set(value) {
                this.mode = value ? "edit" : "view";
            },
        },
        isNewMode() {
            return this.mode === "new";
        },
        isViewMode() {
            return this.mode === "view";
        },
        viewTitle() {
            return this.title;
        },
    },
    watch: {
        "selectedRow.facilityIdx": {
            handler(newVal) {
                if (!newVal) {
                    this.clearData();
                } else {
                    this.loadData();
                }
            },
        },
        allDetails: {
            handler() {
                if (this.selectedRow && this.selectedRow.facilityIdx) this.loadData();
            },
            deep: true,
        },
    },
    methods: {
        transMeterTypeCode(meterTypeCode) {
            return this.meterTypeCodeList.find((item) => item.value === meterTypeCode)?.text;
        },
        setSelectedDetail(row) {
            this.selectedDetail = row ? { ...row } : null;
        },
        // list-Detail Common Functions
        async notifyCancelEdit() {
            // return true : Edit Cancel & Proceed Next Step
            //        false: Stop.
            if (this.isEditMode) {
                const result = await this.alertConfirmWarning("편집중인 내용을 무시하고 종료할까요?");
                if (result.value) return true;
                else return false;
            }
            return true;
        },

        // list-Detail Data Functions
        newData() {
            this.mode = "new";
            // detailInfo는 유지하여 리스트가 그대로 보이도록 함
            return true;
        },

        async loadData() {
            // facilityIdx가 유효한 값인지 확인
            if (!this.selectedRow || !this.selectedRow.facilityIdx) {
                console.warn("facilityIdx is not defined");
                return;
            }

            try {
                const source = Array.isArray(this.allDetails) ? this.allDetails : [];
                const list = source.filter((row) => row && row.facilityIdx === this.selectedRow.facilityIdx);
                this.detailList = list;
                this.detailInfo = list;
                this.selectedDetail = list && list.length > 0 ? { ...list[0] } : null;
                this.mode = "view";
            } catch (e) {
                console.error("Error loading data:", e);
                this.alertNoti(popupMessages.COMMON_NO_SEARCH_DATA_POPUP_MESSAGE);
            }
        },

        clearData() {
            this.detailInfo = null;
            this.detailList = [];
            this.selectedDetail = null;
            this.selectedRow = null;
            this.mode = "view";
            this.$forceUpdate();
        },

        async saveData() {
            const confirm = await this.alertConfirmWarning(popupMessages.COMMON_SAVE_CONFIRM_POPUP_MESSAGE);
            if (!confirm.value) return;
            try {
                const payload = this.$refs.basePanel?.getSavePayload?.() ?? null;
                if (!payload) {
                    this.alertNoti(this.$t("저장할 데이터가 없습니다."));
                    return;
                }

                const isInsert = this.isNewMode || !payload.clbrtnIdx;
                const result = isInsert ? await this.insertClbrn(payload) : await this.updateClbrn(payload);

                if (result.status == 200) {
                    this.$emit("refresh");
                    await this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);

                    if (isInsert) this.$emit("data-insert", payload);
                    else this.$emit("data-updated", payload);

                    // 닫지 않고 목록을 새로 불러와서 유지
                    this.mode = "view";
                    await this.loadData();
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },

        async insertClbrn(param) {
            try {
                let { status, data } = await backEndApi.clbrtnHist.insertClbrn(param);
                if (status !== 200) throw new Error(data.message);
                return { status, data };
            } catch (e) {
                console.error(e);
                throw e;
            }
        },

        async updateClbrn(param) {
            try {
                let { status, data } = await backEndApi.clbrtnHist.updateClbrn(param);
                if (status !== 200) throw new Error(data.message);
                return { status, data };
            } catch (e) {
                console.error(e);
                throw e;
            }
        },

        async deleteData() {
            const result = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
            if (!result.value) return;

            const deletedClbrtnIdx = this.detailInfo.facilityIdx;

            try {
                const result = await backEndApi.clbrtnHist.deleteClbrn(deletedClbrtnIdx);
                if (result.status !== 200) {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                    return;
                }

                this.clearData();
                this.$emit("data-updated", "delete", deletedClbrtnIdx);

                this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
            } catch (e) {
                console.error(e);
            }
        },

        getData() {
            return this.detailInfo;
        },

        // Private Event Handling Functions
        async handleSave(info) {
            if (this.isNewMode) info.action = "create";
            else info.action = "update";
            await this.saveData(info);
        },

        async handleClose(event) {
            const result = await this.notifyCancelEdit();
            if (!result) {
                event && event.preventDefault();
                return false;
            }
            this.clearData();
            this.$emit("closed", this.selectedRow.facilityIdx);
            return true;
        },
    },
};
</script>

<style scoped>
.detail-control {
    margin-bottom: 8px;
}
.detail-content-container {
    height: calc(100% - 70px);
}

/* detail area styles */
.detail-placeholder {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.detail-notification-icon {
    padding: 1rem;
    color: #444;
    font-size: 48px;
}

.detail-notification-text {
    font-size: 15px;
    font-weight: bold;
}

.detail-container {
    height: 100%;
    width: 100%;
    padding: 1rem 1rem 1rem 1rem;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.detail-header {
    margin-bottom: 0px !important;
    padding: 8px 16px 8px 16px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px 6px 0px 0px;
    background-color: #f1f1f1;
    border: solid #ececec 1px;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
}

.detail-header .detail-title {
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.detail-content {
    height: Calc(100% - 50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
    padding: 20px;
    overflow: hidden;
    background-color: white;
    border: solid #ececec 1px;
    border-radius: 0px 0px 6px 6px;
}

.detail-bottom {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* padding-top: 40px; */
}

.detail-bottom-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 4px;
}

.detail-btn {
    flex: 1;
    margin: 0px 4px 0px 4px;
}

.detail-bottom-info {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 8px 4px 8px;
}

/* Badge styles */
.badge {
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
    min-width: 20px;
    padding: 0px 10px 0px 10px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    line-height: 22px;
    border-radius: 8px;
}

.badge.title1 {
    background-color: #ff6d00;
    color: #fff;
}

.badge.title2 {
    background-color: #546e7a;
    color: #fff;
}

.badge.others {
    background-color: #cfd8dc;
    color: #000;
}

.title {
    font-weight: 600;
    margin-right: 20px;
}
</style>
